module.exports = __webpack_public_path__ + "static/cbri-7664e9de70a6a45d4fd06e0a6c8e0baa.jpg";